var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-manager"},[_c('div',{staticClass:"market-manager-left-nav"},[_c('MarketLeft')],1),_vm._v(" "),_c('div',{staticClass:"market-manager-content"},[(_vm.marketComponent === 'market')?_c('Market'):(_vm.marketComponent === 'game')?_c('Game'):(_vm.marketComponent === 'cart')?_c('Cart'):(_vm.marketComponent === 'library')?_c('Library'):(_vm.marketComponent === 'client')?_c('ClientDownload'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8a66364","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/MarketManager.vue
// module id = 198
// module chunks = 0